import React from 'react'
import TagHOC from './TagHOC'
import TagsOverlay from '../templates/TagsOverlay'
import config from '../config'
const _ = require('lodash')
const cdnpath = config.cdnpath

const tags = [
  {
    label: 'hot',
    src: cdnpath+'/images/stickers/stickers-01.png',
    srcSelected: cdnpath+'/images/stickers/stickers-01-filled.png'
  },
  {
    label: 'yuck',
    src: cdnpath+'/images/stickers/stickers-02.png',
    srcSelected: cdnpath+'/images/stickers/stickers-02-filled.png'
  },
  {
    label: 'yes',
    src: cdnpath+'/images/stickers/stickers-03.png',
    srcSelected: cdnpath+'/images/stickers/stickers-03-filled.png'
  },
  {
    label: 'no',
    src: cdnpath+'/images/stickers/stickers-04.png',
    srcSelected: cdnpath+'/images/stickers/stickers-04-filled.png'
  },
  {
    label: 'wtf',
    src: cdnpath+'/images/stickers/stickers-05.png',
    srcSelected: cdnpath+'/images/stickers/stickers-05-filled.png'
  },
  {
    label: 'like',
    src: cdnpath+'/images/stickers/stickers-06.png',
    srcSelected: cdnpath+'/images/stickers/stickers-06-filled.png'
  },
  {
    label: 'slay',
    src: cdnpath+'/images/stickers/stickers-07.png',
    srcSelected: cdnpath+'/images/stickers/stickers-07-filled.png'
  },
  {
    label: 'ex',
    src: cdnpath+'/images/stickers/stickers-09.png',
    srcSelected: cdnpath+'/images/stickers/stickers-09-filled.png'
  },
  {
    label: 'check',
    src: cdnpath+'/images/stickers/stickers-10.png',
    srcSelected: cdnpath+'/images/stickers/stickers-10-filled.png'
  },
  {
    label: 'yikes',
    src: cdnpath+'/images/stickers/stickers-11.png',
    srcSelected: cdnpath+'/images/stickers/stickers-11-filled.png'
  },
  {
    label: 'firstDate',
    src: cdnpath+'/images/stickers/stickers-12.png',
    srcSelected: cdnpath+'/images/stickers/stickers-12-filled.png'
  },
  {
    label: 'secondDate',
    src: cdnpath+'/images/stickers/stickers-13.png',
    srcSelected: cdnpath+'/images/stickers/stickers-13-filled.png'
  },
  {
    label: 'idk',
    src: cdnpath+'/images/stickers/stickers-14.png',
    srcSelected: cdnpath+'/images/stickers/stickers-14-filled.png'
  },
  {
    label: 'noWay',
    src: cdnpath+'/images/stickers/stickers-15.png',
    srcSelected: cdnpath+'/images/stickers/stickers-15-filled.png'
  },
  {
    label: 'wild',
    src: cdnpath+'/images/stickers/stickers-16.png',
    srcSelected: cdnpath+'/images/stickers/stickers-16-filled.png'
  },
  {
    label: 'yaaas',
    src: cdnpath+'/images/stickers/stickers-17.png',
    srcSelected: cdnpath+'/images/stickers/stickers-17-filled.png'
  },
  {
    label: 'basic',
    src: cdnpath+'/images/stickers/stickers-18.png',
    srcSelected: cdnpath+'/images/stickers/stickers-18-filled.png'
  },
  {
    label: 'pepper',
    src: cdnpath+'/images/stickers/stickers-19.png',
    srcSelected: cdnpath+'/images/stickers/stickers-19-filled.png'
  },
  {
    label: 'gross',
    src: cdnpath+'/images/stickers/stickers-20.png',
    srcSelected: cdnpath+'/images/stickers/stickers-20-filled.png'
  },
  {
    label: 'cool',
    src: cdnpath+'/images/stickers/stickers-21.png',
    srcSelected: cdnpath+'/images/stickers/stickers-21-filled.png'
  },
  {
    label: 'love',
    src: cdnpath+'/images/stickers/stickers-22.png',
    srcSelected: cdnpath+'/images/stickers/stickers-22-filled.png'
  },
  {
    label: 'cute',
    src: cdnpath+'/images/stickers/stickers-23.png',
    srcSelected: cdnpath+'/images/stickers/stickers-23-filled.png'
  },
  {
    label: 'champagne',
    src: cdnpath+'/images/stickers/stickers-24.png',
    srcSelected: cdnpath+'/images/stickers/stickers-24-filled.png'
  },
  {
    label: 'sizzlin',
    src: cdnpath+'/images/stickers/stickers-25.png',
    srcSelected: cdnpath+'/images/stickers/stickers-25-filled.png'
  },
  {
    label: 'jam',
    src: cdnpath+'/images/stickers/stickers-26.png',
    srcSelected: cdnpath+'/images/stickers/stickers-26-filled.png'
  },
  {
    label: 'oneHundred',
    src: cdnpath+'/images/stickers/stickers-27.png',
    srcSelected: cdnpath+'/images/stickers/stickers-27-filled.png'
  },
  {
    label: 'cactus',
    src: cdnpath+'/images/stickers/stickers-28.png',
    srcSelected: cdnpath+'/images/stickers/stickers-28-filled.png'
  },
]


const mergeSelectedTags = (selectedTags) => {
  //console.log('merging', selectedTags)
  tags.map( (tag) => {
    const foundTag = _.find(selectedTags, { label: tag.label })
    if(foundTag){
      //console.log('merging', tag.id)
      tag.selected = true
    }else{
      tag.selected = null
    }
    return tag
  })
  return tags
}

const getVisibility = (visibility) => {
    if(visibility === true){
      return 'active'
    }else{
      return ''
    }
  }

class TagsOverlayHOC extends React.Component {

  constructor(props) {
    super(props)
    this.state = { visibleState: false }
    this.handleTagClick = this.handleTagClick.bind(this)
  }


  handleTagClick = (tag) => {
    let selectedTags = this.props.selectedTags
    
      const foundTag = _.find(selectedTags, { label: tag.label })
      //console.log('foundTag', foundTag)
      if(!foundTag){
        //console.log('adding tag', tag)
        if(selectedTags.length < 3){
          selectedTags.push(tag)
        }else{
          return
        }
      }else{
        //console.log('tag', tag)
        selectedTags = _.reject(selectedTags, { label: tag.label })
        //console.log('updated selectedTags', selectedTags)
      }
      this.props.setSelectedTags(selectedTags)

    
  }

  render() {

    const tagsData = mergeSelectedTags(this.props.selectedTags)
    //console.log('new data', tagsData)
    const tags = tagsData.map((tag, i) =>
      <TagHOC key={tag.label} tag={tag} handleTagClick={this.handleTagClick} />
    )

    return (
      <TagsOverlay tags={tags} visibleClass={getVisibility(this.props.visible)} toggleTagsOverLay={this.props.toggleTagsOverLay} >
        {tags}
      </TagsOverlay>
      )
  }

}

export default TagsOverlayHOC



// WEBPACK FOOTER //
// ./src/components/TagsOverlayHOC.js